var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3799_7146)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.0625 13C4.0625 6.78072 8.54765 1.82335 14.5392 1.10546C14.0283 1.04544 13.5144 1.01545 13 1.01563C6.26905 1.01563 1.01562 6.26905 1.01562 13C1.01562 19.731 6.26905 24.9844 13 24.9844C13.13 24.9844 13.2594 24.9823 13.3884 24.9783L13.6158 24.7485C8.09265 23.6572 4.0625 18.8954 4.0625 13Z",
    fill: "url(#paint0_linear_3799_7146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3787 20.3787C20.5043 20.2526 20.6611 20.1619 20.8331 20.1159L24.2332 19.2051C24.4051 19.1591 24.5619 19.0685 24.6876 18.9424C25.0842 18.5458 25.0842 17.9027 24.6876 17.5061C24.5765 17.3945 24.4408 17.3105 24.2915 17.2607L15.6736 14.3881C15.3201 14.2703 14.9147 14.3521 14.6334 14.6334C14.352 14.9148 14.2703 15.3201 14.3881 15.6736L17.2607 24.2914C17.3105 24.4408 17.3945 24.5765 17.5061 24.6876C17.9027 25.0842 18.5458 25.0842 18.9424 24.6876C19.0685 24.5619 19.1591 24.4051 19.2052 24.2332L20.1159 20.8331C20.1619 20.6611 20.2526 20.5043 20.3787 20.3787ZM20.3787 20.3787L24.6876 24.6876",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3884 24.9783C13.2594 24.9823 13.1299 24.9844 13 24.9844C6.26905 24.9844 1.01562 19.731 1.01562 13C1.01562 6.26905 6.26905 1.01562 13 1.01562C19.731 1.01562 24.9844 6.06592 24.9844 12.7969C24.9844 12.956 24.9813 13.1143 24.9753 13.2719M4.875 13H8.9375M8.9375 13H11.2011M8.9375 13C8.9375 15.949 9.7173 18.6533 10.5936 20.7612M8.9375 13C8.9375 10.051 9.7173 7.34671 10.5936 5.23873M15.4064 5.23873C16.0519 6.79142 16.6449 8.66758 16.9126 10.7268",
    stroke: "url(#paint1_linear_3799_7146)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3799_7146",
    x1: 1.01562,
    y1: 1.01562,
    x2: 21.062,
    y2: 16.5869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3799_7146",
    x1: 1.44445,
    y1: -1.67943,
    x2: 29.1602,
    y2: 24.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE56B0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3799_7146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.4242602e8472761ee1470774cbddb789.svg";
export { ForwardRef as ReactComponent };